import React from "react";
import {
  FormattedMessage,
  FormattedDate,
  FormattedNumber,
  FormattedPlural,
  FormattedTime,
} from "react-intl";

import { NavLink } from "react-router-dom";
import "./footer.scss";
import men from "assets/images/men.jpg";
import { Nav } from "react-bootstrap";
import { RiGroupLine } from "react-icons/ri";
import { BsBriefcase, BsBell } from "react-icons/bs";
import dashboard from "assets/images/dashboard.png";
import { useLocation } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import * as userActions from "redux/actions/UserActions";
import * as JobActions from "redux/actions/JobActions";
import * as authActions from "redux/actions/AuthActions";
import { CgTemplate } from "react-icons/cg";
import avatar from "../../../assets/images/male_avatar.png";
import { Image } from "components/shared/imagecomponent/image";
import storage from "utils/storage";

export const HeadFooter = (props) => {
  const userRole = storage.get("humlog_user_role"); // get humlog user role
  const location = useLocation();
  const history = useHistory();
  const { userDetails } = useSelector((state) => state.userReducer);
  const { jobList } = useSelector((state) => state.jobReducer);
  return (
    <></>
  );
};
